export default __webpack_public_path__ + "static/media/AEL.7094390c.png";